export default __webpack_public_path__ + "images/logos/powered-by-flowgate.png?4f59416d1d57d3206dd4b46e0e7fbbcf7132fb09005724bae94d487bbfdeeeab";